<template>
  <div :class="{ 'list-drag': dragaable }">
    <el-form class="form" size="small" label-position="right" ref="groupForm">
      <el-row>
        <el-col :span="10" v-if="teachingContentType == 0">
          <div class="btn-div">
            <BatchDeal :disabled="itemIds.length === 0" :batchData="batchData" @batchDeal="batchDeal"
              v-if="batchData.length > 0" />
            <el-button type="primary" size="small" @click="videoManage">资源管理
            </el-button>
            <el-checkbox :disabled="dragDisabled" v-model="dragaable" class="drag-box mr16">拖拽排序
            </el-checkbox>
          </div>
        </el-col>
        <el-col :span="10" v-if="teachingContentType == 1">
          <div class="btn-div">

            <BatchDeal :disabled="itemIds.length === 0" :batchData="batchData" @batchDeal="batchDeal"
              v-if="batchData.length > 0" />
            <el-button type="primary" size="small" @click="bookManage">图书管理
            </el-button>
            <el-checkbox v-model="dragaable" class="drag-box mr16">拖拽排序
            </el-checkbox>
          </div>
        </el-col>
        <el-col :span="14">
          <Search @search="searchHandle" />
          <!-- <el-form-item label>
            <el-radio-group
              v-model="teachingContentType"
              @change="changeContentType"
            >
              <el-radio-button :label="0">视频</el-radio-button>
              <el-radio-button :label="1">图书</el-radio-button>
            </el-radio-group>
          </el-form-item> -->
        </el-col>

      </el-row>
      <div class="tip-content">
        <div class="tip_msg">提示：请在培训时间开始前将全部课件配置到位。</div>
        <div class="tip_msg">合计资源学时：{{ totalScore }}</div>
      </div>
      <el-row v-if="teachingContentType == 0" key="videoTable">
        <el-col>
          <el-form-item>
            <VideoTable :class="{ 'list-drag': dragaable }" :data="tableList" @selection-change="selectChange"
              row-key="uuid" :empty-text="emptyTableText"></VideoTable>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-else key="bookTable">
        <el-col>
          <el-form-item>
            <BookTable :class="{ 'list-drag': dragaable }" :data="tableList" @selection-change="selectChange"
              row-key="uuid"></BookTable>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item>
            <el-button type="primary" icon="el-icon-arrow-left" @click="$router.back()">返回
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <ConfigSelect v-if="selectDialogInfo.flag" :showSelect="selectDialogInfo" @closeDialog="closeSelect" />
  </div>
</template>

<script>
import {
  getTeachingContentPage, removeTeachingContent, setRequired, updateVideoByDrag, getTeachingResourceScore
} from "@/api/teachingContent";
import { Confirm } from "@/components/Confirm";
import vue from "@/main";
import store from "@/store";
import BatchDeal from "@/views/onlineClass/teaching/content/batchDeal.vue";
import Sortable from "sortablejs";
import BookTable from "./bookTable";
import ConfigSelect from "./configSelect.vue";
import VideoTable from "./videoTable";
import Search from "./seach.vue";

export default {
  name: "questionnaire",
  components: {
    VideoTable,
    BookTable,
    BatchDeal,
    ConfigSelect,
    Search
  },
  data() {
    let batchData = [];
    // 针对上级路由onlineClass
    const permissionList = store.getters.permissionList["onlineClass"];
    if (permissionList && permissionList.includes("teachingContent:delete")) {
      batchData.push({
        paramValue: "批量移除",
        paramKey: "1",
        way: "batchDelete",
      });
    }
    // if (permissionList && permissionList.includes("teachingContent:require")) {
    //   batchData.push({
    //     paramValue: "批量设为必修",
    //     paramKey: "2",
    //     way: "batchRequired",
    //   });
    //   batchData.push({
    //     paramValue: "批量取消必修",
    //     paramKey: "3",
    //     way: "batchCancelRequired",
    //   });
    // }
    return {
      dragaable: false, //控制拖拽排序,
      teachingContentType: 0, // 教学内容类型
      classId: "",
      dataname: "",
      editId: null,
      tableList: [],
      checkArray: [],
      batchData,
      emptyTableText: '尚未添加任何视频，点击右上角【视频管理】可进行视频添加',
      selectDialogInfo: {
        flag: false
      },
      totalScore: 0,
    };
  },
  computed: {
    itemIds() {
      return this.checkArray.map((item) => item.uuid);
    },
    dragDisabled() {
      if (this.tableList.length < 2) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dragaable = false;
        return true;
      }
      return false;
    },
  },
  watch: {
    dragaable(val) {
      this.rowDrop(val);
    },
  },
  created() {
    this.classId = this.$route.query.id;
    this.editId = this.$route.query.id;
    this.$nextTick(() => {
      this.getResourceTotal();
      this.searchHandle({});
    });
    vue.$on("removeTeachingContent", (item) => {
      this.removeTeachingContent(item);
    });
    vue.$on("setRequired", (item, status) => {
      this.setRequired([item.uuid], status);
    });

    // this.searchHandle({});
  },
  beforeDestroy() {
    vue.$off("setRequired");
  },
  methods: {
    batchDeal(way) {
      this[way]();
    },
    batchDelete() {
      this.deleteContent();
    },
    batchRequired() {
      this.setRequired(this.itemIds, 1);
    },
    batchCancelRequired() {
      this.setRequired(this.itemIds, 0);
    },
    // 切换教学内容类型
    changeContentType(val) {
      this.teachingContentType = val;
      this.tableList = [];
      this.searchHandle({});
    },
    // 列表搜索
    searchHandle(params = {}) {
      if (Object.keys(params).length > 0) {
        this.emptyTableText = '没有搜索到相关资源'
      } else {
        this.emptyTableText = this.$options.data().emptyTableText;        
      }
      params.classId = this.classId;
      params.teachingContentType = this.teachingContentType;
      this.dataname = params;
      getTeachingContentPage(params).then((res) => {
        if (!res || res.code !== 0) return;
        this.tableList = res.data;
      });
    },

    getResourceTotal() {
      getTeachingResourceScore({
        classId: this.classId,
        teachingContentType: this.teachingContentType
      }).then(res => {
        this.totalScore = res.data;
      })
    },
    addGroupUsers(groupUserList) {
      this.groupForm.groupUserList = groupUserList;
    },
    // 移除组员
    async removeTeachingContent(item) {
      try {
        await Confirm(`确认移除该视频教学内容吗？`, "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        });
        removeTeachingContent({ uuids: [item.uuid] }).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "移除成功",
            type: "success",
          });
          this.searchHandle({});
        });
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    // 设置/取消必修
    setRequired(ids, status) {
      let params = {
        isRequied: status,
        uuid: ids,
      };
      setRequired(params).then((res) => {
        if (!res || res.code != 0) return;
        this.$message({
          message: res.msg,
          type: "success",
        });
        this.searchHandle({});
      });
    },
    // 拖拽排序
    rowDrop(flag) {
      if (!flag) {
        // 关闭拖拽功能时销毁Sortable对象
        this.sort && this.sort.destroy();
      } else {
        const _this = this;
        const tbody = document.querySelector(".el-table__body-wrapper tbody");
        this.sort = Sortable.create(tbody, {
          animation: 180,
          delay: 0,
          sort: true,
          draggable: ".el-table__row",

          onEnd({ oldIndex, newIndex }) {
            if (oldIndex === newIndex) return;
            const oldRow = _this.tableList[oldIndex];
            // 和其他拖拽偏移量规则相反
            let offset = newIndex - oldIndex;
            let params = {
              offset: offset,
              uuid: oldRow.uuid,
            };
            updateVideoByDrag(params).then((res) => {
              if (!res || res.code != 0) return;
              _this.$message({
                message: "排序成功",
                type: "success",
              });
              const currR = _this.tableList.splice(oldIndex, 1)[0];
              _this.tableList.splice(newIndex, 0, currR);
            });
          },
        });
      }
    },
    // 视频管理
    videoManage() {
      // vue.$emit("videoManage", this.$route.query.id);
      this.selectDialogInfo = {
        flag: true,
        classId: this.classId,
        type: 0,
      }
    },
    // 图书管理
    bookManage() {
      // vue.$emit("bookManage", this.$route.query.id);
      this.selectDialogInfo = {
        flag: true,
        classId: this.classId,
        type: 1,
      }
    },
    selectChange(selections) {
      this.checkArray = selections;
    },
    // 关闭资源选择弹窗
    closeSelect(flag) {
      this.selectDialogInfo.flag = false;
      if (flag) {
        this.getResourceTotal();
        this.searchHandle({});
      }
    },
    // 批量教学内容
    deleteContent() {
      let content = "视频";
      if (this.teachingContentType == 1) {
        content = "图书";
      }
      this.$confirm(`确认批量移除选中的` + content + `吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          removeTeachingContent({ uuids: this.itemIds }).then((res) => {
            if (!res || res.code != 0) return;
            this.$message({
              message: "移除成功",
              type: "success",
            });
            this.searchHandle({});
          });
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.tip-content {
  display: flex;
  justify-content: space-between;
  align-items: center;


  .tip_msg {
    font-size: 14px;
    line-height: 32px;
    margin-bottom: 12px;
  }

}

.question-add {
  $textColor: #51627d;
  $textSize: 12px;

  @mixin text {
    color: $textColor;
    font-size: $textSize;
  }

  /deep/ .el-dialog__body {
    padding: 30px 30px 30px 20px;
  }

  .form {
    padding: 10px 20px;
  }

  .title {
    color: #343c4a;
    font-size: 16px;
    margin: 0;
    padding: 14px 0 10px 34px;
    border-bottom: 1px solid #edf1f8;
  }

  .delete-choose {
    position: absolute;
    top: 10px;
    right: -19px;
    font-size: 14px;
    cursor: pointer;
  }

  .form-select {
    width: 100%;

    &.has-btn {
      width: calc(100% - 120px);
    }
  }

  .mr16 {
    margin-right: 16px;
  }
}

.btn-div {
  // float: right;
  margin-bottom: 12px;

  /deep/ .drag-box {
    margin-left: 12px;
    .el-checkbox__label {
      font-size: 12px;
      color: #3564ae;
      font-weight: normal;
    }
  }
}
</style>
